// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DocumentDetailsQueryVariables = Types.Exact<{
  documentIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type DocumentDetailsQuery = { __typename?: 'Query', documents: { __typename?: 'DocumentConnection', edges?: Array<{ __typename?: 'DocumentEdge', node?: { __typename?: 'Document', id: string, name: string, type: Types.DocumentType } | null } | null> | null } };

export const Operations = {
  Query: {
    DocumentDetails: 'DocumentDetails' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const DocumentDetailsDocument = gql`
    query DocumentDetails($documentIds: [ID!]!) {
  documents(where: {idIn: $documentIds}) {
    edges {
      node {
        id
        name
        type
      }
    }
  }
}
    `;

/**
 * __useDocumentDetailsQuery__
 *
 * To run a query within a React component, call `useDocumentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentDetailsQuery({
 *   variables: {
 *      documentIds: // value for 'documentIds'
 *   },
 * });
 */
export function useDocumentDetailsQuery(baseOptions: Apollo.QueryHookOptions<DocumentDetailsQuery, DocumentDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentDetailsQuery, DocumentDetailsQueryVariables>(DocumentDetailsDocument, withFetchPolicyContext(options));
      }
export function useDocumentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentDetailsQuery, DocumentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentDetailsQuery, DocumentDetailsQueryVariables>(DocumentDetailsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useDocumentDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DocumentDetailsQuery, DocumentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DocumentDetailsQuery, DocumentDetailsQueryVariables>(DocumentDetailsDocument, withFetchPolicyContext(options));
        }
export type DocumentDetailsQueryHookResult = ReturnType<typeof useDocumentDetailsQuery>;
export type DocumentDetailsLazyQueryHookResult = ReturnType<typeof useDocumentDetailsLazyQuery>;
export type DocumentDetailsSuspenseQueryHookResult = ReturnType<typeof useDocumentDetailsSuspenseQuery>;
export type DocumentDetailsQueryResult = Apollo.QueryResult<DocumentDetailsQuery, DocumentDetailsQueryVariables>;